const getOperationInfo = (query)=>{
    const operationNode = query.definitions[0];
    let name = 'anonymous';
    // Fallback name when the operation has been malformed but still send to the BE
    let type = operationNode.kind;
    if (operationNode.kind === 'OperationDefinition') {
        type = operationNode.operation;
        if (operationNode.name) {
            name = operationNode.name.value;
        }
    }
    return [
        type,
        name
    ];
};
const handleError = (query, error)=>{
    const [type, name] = getOperationInfo(query);
    console.error(`[${type}] - ${name} - error`, {
        error
    });
};

export { getOperationInfo, handleError };
//# sourceMappingURL=helpers.js.map
